import { VydejMenu } from '../../vydej/vydejmenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';
import { NewOrder } from '../../orders/components/NewOrder';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';

const VydejNewOrderPage = () => {
  const { apps } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.vydej ? (
        <AppWrapper appType={APP_TYPE.VYDEJ} menu={<VydejMenu />}>
          <NewOrder />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default VydejNewOrderPage;
